import React, { useState } from "react";
import { Container, Row, Col, Badge } from "react-bootstrap";
import "./../../../assets/css/general/Notifications/notifications.css";

// ── Notifications Data ────────────────────────────────────────────────────────
const NOTIFICATIONS = [
  {
    id: 1,
    type: "announcement",
    title: "System maintenance scheduled",
    message:
      "Platform will undergo maintenance on Saturday 12 Apr, 2am–4am PKT. All sessions will be temporarily paused.",
    time: "2 min ago",
    unread: true,
    actions: ["Edit", "Delete"],
  },
  {
    id: 2,
    type: "report",
    title: "Student reported a mentor",
    message:
      "Ali Hassan (Student) has reported Mentor Usman Tariq for missing 3 consecutive sessions without notice.",
    time: "18 min ago",
    unread: true,
    actions: ["View details", "Deactivate mentor", "Dismiss report"],
  },
  {
    id: 3,
    type: "student",
    title: "New student joined",
    message:
      "Sara Malik has signed up and enrolled in Python Fundamentals. Awaiting mentor assignment.",
    time: "1 hr ago",
    unread: true,
    actions: ["View profile"],
  },
  {
    id: 4,
    type: "session",
    title: "Session starting in 30 minutes",
    message:
      "Mentor Ayesha Noor has a session with 5 students for React.js — Advanced Hooks at 4:00 PM PKT.",
    time: "2 hr ago",
    unread: false,
    actions: [],
  },
  {
    id: 5,
    type: "assignment",
    title: "Assignment deadline approaching",
    message:
      "JavaScript Arrays assignment is due in 24 hours. 14 out of 20 students have submitted. 6 students are pending.",
    time: "3 hr ago",
    unread: false,
    actions: ["View submissions"],
  },
  {
    id: 6,
    type: "report",
    title: "Mentor reported a student",
    message:
      "Mentor Bilal Ahmed has reported student Hamza Khan for consistently missing sessions and ignoring assignments.",
    time: "5 hr ago",
    unread: false,
    actions: ["View details", "Deactivate student", "Dismiss report"],
  },
  {
    id: 7,
    type: "system",
    title: "AI Tutor usage spike detected",
    message:
      "250+ AI Tutor sessions were initiated in the last 24 hours — a 40% increase. System is operating normally.",
    time: "Yesterday",
    unread: false,
    actions: [],
  },
  {
    id: 8,
    type: "announcement",
    title: "New course launched: Flutter Dev",
    message:
      "Admin has launched a new course — Flutter Development. Mentors have been notified to apply. Students can now enroll.",
    time: "Yesterday",
    unread: false,
    actions: [],
  },
];

// ── Filter Config ────────────────────────────────────────────────────────────
const FILTERS = [
  { key: "all",          label: "All notifications",  color: "#185fa5", pillClass: "pill-blue"   },
  { key: "announcement", label: "Announcements",      color: "#534ab7", pillClass: "pill-purple" },
  { key: "session",      label: "Session alerts",     color: "#185fa5", pillClass: "pill-blue"   },
  { key: "student",      label: "New students",       color: "#0f6e56", pillClass: "pill-teal"   },
  { key: "report",       label: "Reports",            color: "#e24b4a", pillClass: "pill-red"    },
  { key: "assignment",   label: "Assignments",        color: "#ba7517", pillClass: "pill-amber"  },
  { key: "system",       label: "System",             color: "#6c757d", pillClass: "pill-gray"   },
];

// ── Icon by type ─────────────────────────────────────────────────────────────
const TypeIcon = ({ type }) => {
  const icons = {
    announcement: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M22 3l-8.646 8.646M22 3H15M22 3v7" />
        <path d="M21 12v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6" />
      </svg>
    ),
    report: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" strokeLinecap="round" />
      </svg>
    ),
    student: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="8.5" cy="7" r="4" />
        <line x1="20" y1="8" x2="20" y2="14" />
        <line x1="23" y1="11" x2="17" y2="11" />
      </svg>
    ),
    session: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
    assignment: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14,2 14,8 20,8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
      </svg>
    ),
    system: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14" />
      </svg>
    ),
  };
  return icons[type] || icons.system;
};

// ── Action button style helper ───────────────────────────────────────────────
const getActionClass = (label) => {
  const l = label.toLowerCase();
  if (l.includes("deactivate") || l.includes("delete")) return "act-danger";
  if (l.includes("dismiss"))  return "act-warning";
  if (l.includes("approve"))  return "act-success";
  return "act-default";
};

// ── Tag label helper ─────────────────────────────────────────────────────────
const TAG_LABELS = {
  announcement: "Announcement",
  report:       "Report",
  student:      "New student",
  session:      "Session alert",
  assignment:   "Assignment",
  system:       "System",
};

// ── Count per type ───────────────────────────────────────────────────────────
const countByType = (type) =>
  type === "all"
    ? NOTIFICATIONS.length
    : NOTIFICATIONS.filter((n) => n.type === type).length;

// ── Main Component ────────────────────────────────────────────────────────────
const Notifications = () => {
  const [activeFilter, setActiveFilter]   = useState("all");
  const [notifications, setNotifications] = useState(NOTIFICATIONS);
  const [showAnnounce, setShowAnnounce]   = useState(false);
  const [announceText, setAnnounceText]   = useState("");

  const filtered =
    activeFilter === "all"
      ? notifications
      : notifications.filter((n) => n.type === activeFilter);

  const unreadCount = notifications.filter((n) => n.unread).length;

  const markAllRead = () =>
    setNotifications((prev) => prev.map((n) => ({ ...n, unread: false })));

  const dismissNotif = (id) =>
    setNotifications((prev) => prev.filter((n) => n.id !== id));

  const sendAnnouncement = () => {
    if (!announceText.trim()) return;
    const newNotif = {
      id: Date.now(),
      type: "announcement",
      title: "New system announcement",
      message: announceText,
      time: "Just now",
      unread: true,
      actions: ["Edit", "Delete"],
    };
    setNotifications((prev) => [newNotif, ...prev]);
    setAnnounceText("");
    setShowAnnounce(false);
  };

  return (
    <div className="notif-page">
      <Container fluid="lg" className="notif-container">
        <div className="notif-layout">

          {/* ── SIDEBAR ── */}
          <div className="notif-sidebar">
            <div className="sidebar-head">
              <h2>Notifications</h2>
              <p>Admin control center</p>
            </div>

            {FILTERS.map((f) => (
              <button
                key={f.key}
                className={`filter-btn ${activeFilter === f.key ? "active" : ""}`}
                onClick={() => setActiveFilter(f.key)}
              >
                <span className="f-left">
                  <span className="f-dot" style={{ backgroundColor: f.color }} />
                  {f.label}
                </span>
                <span className={`count-pill ${f.pillClass}`}>
                  {countByType(f.key)}
                </span>
              </button>
            ))}

            <div className="sidebar-divider" />

            {/* Admin Actions Panel */}
            <div className="admin-panel">
              <p>Send a system-wide announcement to all users.</p>
              <button
                className="admin-action-btn"
                onClick={() => setShowAnnounce((p) => !p)}
              >
                + New Announcement
              </button>
              <button className="admin-action-btn outline" onClick={markAllRead}>
                Mark all as read
              </button>
            </div>

            {/* Announce input */}
            {showAnnounce && (
              <div className="announce-input-wrap">
                <textarea
                  placeholder="Type your announcement..."
                  value={announceText}
                  onChange={(e) => setAnnounceText(e.target.value)}
                  rows={3}
                />
                <button className="admin-action-btn" onClick={sendAnnouncement}>
                  Send
                </button>
              </div>
            )}
          </div>

          {/* ── MAIN ── */}
          <div className="notif-main">

            {/* Topbar */}
            <div className="notif-topbar">
              <div className="topbar-title">
                <h3>
                  {FILTERS.find((f) => f.key === activeFilter)?.label}
                  <span className="notif-count">({filtered.length})</span>
                </h3>
                {unreadCount > 0 && (
                  <span className="unread-badge">{unreadCount} unread</span>
                )}
              </div>
              <div className="topbar-actions">
                <button className="tb-btn" onClick={markAllRead}>
                  Mark all read
                </button>
                <button
                  className="tb-btn primary"
                  onClick={() => setShowAnnounce((p) => !p)}
                >
                  + Announce
                </button>
              </div>
            </div>

            {/* Notification List */}
            <div className="notif-list">
              {filtered.length === 0 ? (
                <div className="empty-state">No notifications in this category.</div>
              ) : (
                filtered.map((notif) => (
                  <div
                    key={notif.id}
                    className={`notif-item ${notif.unread ? "unread" : ""}`}
                  >
                    {/* Icon */}
                    <div className={`ni-icon ni-${notif.type}`}>
                      <TypeIcon type={notif.type} />
                    </div>

                    {/* Body */}
                    <div className="ni-body">
                      <div className="ni-header">
                        <span className="ni-title">{notif.title}</span>
                        <span className="ni-time">{notif.time}</span>
                      </div>
                      <p className="ni-msg">{notif.message}</p>
                      <span className={`ni-tag tag-${notif.type}`}>
                        {TAG_LABELS[notif.type]}
                      </span>

                      {/* Action buttons */}
                      {notif.actions.length > 0 && (
                        <div className="ni-actions">
                          {notif.actions.map((action) => (
                            <button
                              key={action}
                              className={`ni-act-btn ${getActionClass(action)}`}
                              onClick={() => {
                                if (
                                  action === "Delete" ||
                                  action.toLowerCase().includes("deactivate")
                                ) {
                                  dismissNotif(notif.id);
                                }
                              }}
                            >
                              {action}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>

            {/* Footer */}
            <div className="notif-footer">
              <button className="load-more-btn">Load older notifications</button>
            </div>

          </div>
        </div>
      </Container>
    </div>
  );
};

export default Notifications;